/*
 * Created by jmeo at 2021-06-02
 * FileName: Authorize.tsx
 * 信息查询授权书
 */

import {setTitle} from "@src/util";

export default function () {
    setTitle('信息查询授权书')
    return <div className="agreement-page">
        <h2>信息查询授权书</h2>
        <p><strong>【特别提示】</strong>本授权书经授权人书面签署，在签订本授权书之前，请申请人务必仔细阅读本授权书的全部条款，关注您在授权书中的权利和义务。 </p>
        <p>
            本人（本企业）同意并不可撤销地授权<strong>【润雨同舟（深圳）融资租赁有限公司】</strong>，在<strong>【融资租赁】</strong>业务过程中（从业务申请至业务终止），基于约定用途：包括但不限于贷款审核、贷后管理、担保或依法或经有权部门要求等，有权通过第三方服务机构（包括但不限于中国人民银行征信中心、百行征信数据公司等第三方权威征信机构、及其他第三方数据机构等）对本人（本企业）提交的信息进行核实；有权通过前述第三方服务机构采集、使用本人（本企业）的通讯信息、借贷信息、消费信息、财务信息等（企业基本信息、法定代表人信息、股东信息、董事信息、监事信息、高管信息、税务信息、资产信息等），包括可能对信息主体产生负面影响的不良信息，以判断、识别业务风险。 </p>
        <p>
            同时，本人（本企业）不可撤销的授权第三方服务机构基于约定用途，有权通过合法存有本人（本企业）信息的机构收集本人（本企业）的信息，并可进行相关处理（包括但不限于整理、保存、加工、提供）；本人（本企业）不可撤销的授权合法存有本人（本企业）信息的机构向第三方机构提供本人（本企业）的上述信息。 </p>
        <p>
            本人（本企业）同意并不可撤销地授权<strong>【润雨同舟（深圳）融资租赁有限公司】</strong>向第三方服务机构报送、提供、共享被授权人通过相关渠道获取的本人（本企业）信息，并授权第三方机构对获取的本人（本企业）的信息依法进行相关处理（包括但不限于整理、保存、加工、提供）等其他合法用途。 </p>
        <p>授权人（即申请人）承诺本授权效力具有独立性，不因其他合同的任何条款无效而失效。 </p>
        <p>授权人（即申请人）已知悉本授权书所有内容的意义及由此产生的法律效力，自愿做出上述授权，本授权申明是授权人（即申请人）真实的意思表示，授权人（即申请人）同意承担由此带来的一切法律后果。 </p>
        <p>特此授权！ </p>
        <br/>
    </div>
}